import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { OpportunityListItem } from '@features/opportunities/models/opportunity';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-opportunity-list',
  templateUrl: './opportunity-list.component.html',
  styleUrls: ['./opportunity-list.component.scss']
})
export class OpportunityListComponent implements OnInit {

  public opportunities$!: Observable<OpportunityListItem[]>;

  constructor(
    public router: Router,
    private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.opportunities$ = this.dashboardService.getOpportunities();
  }

}
